import { IList } from '@pnp/sp/presets/all';
import {
    FieldType,
    SharePointService,
    UpdateService,
} from 'sp-office365-framework';

export class UpdateToVersion1101Component {
    constructor(
        private _sharePointService: SharePointService,
        private _updateService: UpdateService
    ) {}

    run() {
        const promise = new Promise<void>(async (resolve, reject) => {
            const projectList: IList = this._sharePointService.web.lists.getByTitle(
                'Aufträge'
            );
            let docTemplateList: IList;

            const promises = [
                // Add List Dokumentenvorlagen
                await this._updateService.addList(
                    'Dokumentenvorlagen',
                    '',
                    101,
                    {
                        EnableVersioning: true,
                    }
                ),
                // Get List Dokumentenvorlagen
                await new Promise<void>((resolve) => {
                    docTemplateList = this._sharePointService.web.lists.getByTitle(
                        'Dokumentenvorlagen'
                    );
                    resolve();
                }),
                // Add Field Antragssumme to List Aufträge
                await this._updateService.addField(
                    projectList,
                    'Antragssumme',
                    FieldType.Currency
                ),
                // Add Field Nebenkosten to List Aufträge
                await this._updateService.addField(
                    projectList,
                    'Nebenkosten',
                    FieldType.Number
                ),
                // Add Field Fremdleistung to List Aufträge
                await this._updateService.addField(
                    projectList,
                    'Fremdleistung',
                    FieldType.Currency
                ),
            ];

            Promise.all(promises)
                .then(() => resolve())
                .catch((error) => reject(error));
        });
        return promise;
    }
}
